module.exports = __webpack_public_path__ + "img/icon_cs_feature_jobs.50900849.png";